import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { AccountIconComponent } from '../account-icon/account-icon.component';
import { HubUser } from '../../checklist/types/generated/checklist-models';
import { ThemeService } from '../../../services/theme.service';
import { PresenceColorService } from '../../checklist/services/presence-color.service';
import {
  PRESENCE_OVERFLOW_COLOR,
  PresenceColor,
} from '../../checklist/utils/presence-color.util';
import {
  orderViewersBySlot,
  viewerInitials,
  viewerLabel,
} from '../../checklist/utils/presence-viewer.util';

@Component({
  selector: 'app-presence-avatars',
  imports: [AccountIconComponent],
  templateUrl: './presence-avatars.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresenceAvatarsComponent {
  private readonly themeService = inject(ThemeService);
  private readonly presenceColors = inject(PresenceColorService);

  readonly viewers = input<readonly HubUser[]>([]);
  readonly maxVisible = input(3);

  readonly isNightMode = this.themeService.isNightMode;
  readonly overflowColor = PRESENCE_OVERFLOW_COLOR;

  private readonly orderedViewers = computed(() =>
    orderViewersBySlot(this.viewers(), id => this.presenceColors.slotOf(id))
  );

  readonly visibleViewers = computed(() =>
    this.orderedViewers().slice(0, this.maxVisible())
  );

  readonly hiddenViewers = computed(() =>
    this.orderedViewers().slice(this.maxVisible())
  );

  readonly overflowInitials = computed(() => `+${this.hiddenViewers().length}`);

  readonly hiddenViewersLabel = computed(() =>
    this.hiddenViewers()
      .map(viewer => this.viewerLabel(viewer))
      .join(', ')
  );

  viewerLabel(viewer: HubUser): string {
    return viewerLabel(viewer);
  }

  viewerInitials(viewer: HubUser): string {
    return viewerInitials(viewer);
  }

  viewerColor(viewer: HubUser): PresenceColor {
    return this.presenceColors.colorOf(viewer.userId);
  }
}
